import { createFileRoute } from "@tanstack/react-router";
import AppLayout from "../../components/AppLayout";
import Footer from "../../components/Footer/Footer";
import { ThemeSlot } from "../../themes/slots";
import OrderDetails from "../../screens/OrderDetails";

export const Route = createFileRoute("/c/order/$orderId")({
  component: () => (
    <AppLayout>
      <ThemeSlot slot="header" isProfile={true} />
      <RouteComponent />
      <Footer />
    </AppLayout>
  ),
});

function RouteComponent() {
  return <OrderDetails />;
}
